import {UserState} from './state';

export const userInitialState: UserState = {
  search: {
    users: [],
    invites: []
  }
};